import { render, staticRenderFns } from "./MultipleUsersSelectWithEmailNotification.vue?vue&type=template&id=56a3c138&"
import script from "./MultipleUsersSelectWithEmailNotification.vue?vue&type=script&lang=js&"
export * from "./MultipleUsersSelectWithEmailNotification.vue?vue&type=script&lang=js&"
import style0 from "./MultipleUsersSelectWithEmailNotification.vue?vue&type=style&index=0&id=56a3c138&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports